export default __webpack_public_path__ + "static/media/LookingAtBoom.f6bda409.jpg";